import React, { Suspense } from "react";
import { AppContainer } from "react-hot-loader";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import Routes from "./Routes";
import i18n from "~/components/i18n";
import ContentLoaderSimple from "~/components/element/ContentLoaderSimple";
import "./styles/Login.less";

const root = document.getElementById("root");

export default function doRender(routes) {
  const router = (
    <Suspense fallback={<ContentLoaderSimple />}>
      <I18nextProvider i18n={i18n}>
        <AppContainer>
          <BrowserRouter basename="/login">{routes}</BrowserRouter>
        </AppContainer>
      </I18nextProvider>
    </Suspense>
  );

  render(router, root);
}

i18n.init(err => {
  if (err) {
    window.alert("Something went wrong. Please reload this page.");
    return;
  }
  doRender(Routes);
});

if (module.hot) {
  module.hot.accept("./Routes", () => {
    // doRender(Routes);
    window.reloadApp(); // temporary fix to mobx issue
  });
}
